import {Eq, eqString, getStructEq} from 'fp-ts/lib/Eq';
import * as O from 'fp-ts/lib/Option';
import {Errors} from 'Shared/components/ErrorPopover';
import {ToMatchOptions} from '../../Shared/utilities/MapDiscriminatedUnion';

export class EmptyString {
  public readonly key = 'Empty';
  public readonly value = '';
}

export class NonEmptyString {
  public static create(value: string) {
    return value !== '' ? new NonEmptyString(value) : new EmptyString();
  }

  public readonly key = 'NonEmpty';

  private constructor(public readonly value: string) {}
}

export type StringUnion = EmptyString | NonEmptyString;

export const getNonEmptyStringErrors = (value: StringUnion) =>
  Errors.standardErrors({value: isNonEmptyString(value) ? [] : ['Please provide a value.']});

export type StringOptions<TReturn> = ToMatchOptions<StringUnion, 'key', TReturn>;

export const matchString = <TReturn>(value: StringUnion, options: StringOptions<TReturn>): TReturn => {
  switch (value.key) {
    case 'Empty':
      return options.Empty(value);
    case 'NonEmpty':
      return options.NonEmpty(value);
  }
};

export const eqStringUnion: Eq<StringUnion> = getStructEq({
  value: eqString,
});

export const isNonEmptyString = (value: StringUnion): value is NonEmptyString => value instanceof NonEmptyString;
export const isEmptyString = (value: StringUnion): value is EmptyString => value instanceof EmptyString;
export const toOption = (value: StringUnion) => (isNonEmptyString(value) ? O.some(value) : O.none);
